/*
  INSERT INTO _31rs (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _icn, _pfx,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 
    1, 1, 1, 1, 
    '1', '山内地区センター',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _31rs (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _icn, _pfx,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 
    2, 1, 1, 2, 
    '1', '岩草台地区センター',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _31rs (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _icn, _pfx,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 
    3, 1, 1, 3, 
    '1', '美しが丘西地区センター',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _31rs (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _icn, _pfx,
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    1, 
    4, 1, 1, 4, 
    '1', '奈良地区センター',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

*/

export const _31z = { // 部門
  _31r: { // 部門
    v0: {
      itlz: {
//        _31r_20r1k: -1,
        _31r_30r1f: -1,
        _31r_31r1f: -1,
      },
      fldz: {
/*
        _31r_20r1k: {
          pfx: 'ドメイン'
        },
*/
        _31r_30r1f: {
          pfx: '法人'
        },
        _31r_31r1f: {
          pfx: '上位部門'
        },
        _icn: {
          pfx: '部門ID'
        },
        _pfx: {
          pfx: '部門名'
        }
      },
    },
  },
};
